export default [
  { value: 'http://mfrlogin.com', label: 'http://mfrlogin.com' },
  { value: 'mfrlogin.com', label: 'mfrlogin.com' },
  { value: 'www.mfrlogin.com', label: 'www.mfrlogin.com' },
];
